import apiClient from "./apiClient";
import { shareInFlight } from "./inFlight";

// Deduplicated per case: the effect that drives it fires twice under
// StrictMode, which sent two requests and raised two error dialogs for one
// press.
export const fetchPetQuote = (payload) =>
  shareInFlight(`pet-premium:${payload?.case_id ?? ""}`, () =>
    apiClient.post("/pet/pet-premium", payload).then(({ data }) => data)
  );

export const finalisePetPlan = async (payload) => {
  const { data } = await apiClient.post("/pet/pet-finalise", payload);
  return data;
};

// The server stamps the purchase date — it is a server-owned column.
export const recordPetPurchase = async (caseId) => {
  const { data } = await apiClient.post(`/pet/${caseId}/purchase`);
  return data;
};

export const syncPetData = async (caseId, body) => {
  const { data } = await apiClient.post("/pet/sync", { case_id: caseId, ...body });
  return data;
};

export const fetchPetData = async (caseId) => {
  const { data } = await apiClient.get(`/pet/${caseId}`);
  return data;
};
